export default __webpack_public_path__ + "static/media/purple.fd2669a7.png";